/* eslint-disable */
import React, { useState, useEffect } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import GridItem from "components/Grid/GridItem.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import { API_POST } from "../../services/api.service";
import Typography from '@material-ui/core/Typography';
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import ErrorBoundary from '../../hoc/ErrorBoundary/ErrorBoundary';


import Card from "components/Card/Card.jsx";
import EmailTemplateList from '../CommTemplates/EmailTemplateList';
import SMSTemplateList from '../CommTemplates/SMSTemplateList';
import WhatsAppTemplateList from '../CommTemplates/WhatsAppTemplateList';
import EmailConfiguration from "./EmailConfiguration";
import SMSSetupList from "../SMSSetup/SMSSetupList";
import WhatsAppSetupList from "../WhatsAppSetup/WhatsAppSetupList";
import CallingSetupList from "../CallingSetup/CallingSetupList";
import NotificationPage from "./Notification";
import BasicSettings from "./BasicSettings";
import LeadScoringList from "../LeadScoring/LeadScoringList";


const ConfigurationPage = (props) => {
    const { user, history, classes } = props;
    const [activeTab, setActiveTab] = useState(0);
    const [cid, setCid] = useState("");

    // Equivalent to componentWillMount
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tab = urlParams.get('tab');
        if (tab) {
            setActiveTab(parseInt(tab));
        }
    }, []); // Empty dependency array means this runs once on mount

    const handleChange = (event, value) => {
        setActiveTab(value);
        history.push('?tab=' + value);
    };

    return (
        <GridContainer>


                <GridItem xs={12} sm={12} md={12}>
                    <CustomTabs
                        title=""
                        TabProps={{
                            onChange: handleChange,
                        }}
                        selectedValue={activeTab}
                        headerColor="info"
                        tabs={[
                            {
                                tabName: "Email Config",
                                tabContent: (
                                    <ErrorBoundary name="EmailTemplates">
                                        <EmailConfiguration
                                            user={user}
                                            history={history}
                                        />
                                    </ErrorBoundary>
                                ),
                            },
                            {
                                tabName: "SMS Config",
                                tabContent: (
                                    <ErrorBoundary name="SMSTemplates">
                                        <SMSSetupList user={user}
                                            history={history}></SMSSetupList>

                                    </ErrorBoundary>
                                ),
                            },
                            {
                                tabName: "WhatsApp Config",
                                tabContent: (
                                    <ErrorBoundary name="EmailTemplates">
                                        <WhatsAppSetupList user={user}
                                            history={history}></WhatsAppSetupList>
                                    </ErrorBoundary>
                                ),
                            },
                            {
                                tabName: "Calling Setup",
                                tabContent: (
                                    <ErrorBoundary name="EmailTemplates">
                                        <CallingSetupList user={user}
                                            history={history}></CallingSetupList>
                                    </ErrorBoundary>
                                ),
                            },
                            {
                                tabName: "Daily Report",
                                tabContent: (
                                    <ErrorBoundary name="EmailTemplates">
                                        <NotificationPage user={user}
                                            history={history}></NotificationPage>
                                    </ErrorBoundary>
                                ),
                            },
                            {
                                tabName: "Basic Settings",
                                tabContent: (
                                    <ErrorBoundary name="EmailTemplates">
                                        <BasicSettings user={user}
                                            history={history}></BasicSettings>
                                    </ErrorBoundary>
                                ),
                            },
                            {
                                tabName: "Lead Scoring",
                                tabContent: (
                                    <ErrorBoundary name="LeadScoringList">
                                        <LeadScoringList user={user}
                                            history={history}></LeadScoringList>
                                    </ErrorBoundary>
                                ),
                            },


                        ]}
                    />
                </GridItem>
            </GridContainer>
        );
};
export default withStyles(dashboardStyle)(ConfigurationPage);
